import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  inject,
  Input,
  OnInit,
  signal
} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {
  ControlValueAccessor,
  FormControl,
  FormGroup,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule
} from '@angular/forms';
import {FormulaControllerService} from '../../../apiModule1/api/formula-controller.service';
import {CommunicationService} from '../../../../core/services/communication.service';

export interface CheckFormulaResponse {
  code: string;
  replacedFormula: string;
  value: number;
}

@Component({
  selector: 'pas-formula-constructor',
  standalone: true,
  imports: [
    MatIcon,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './formula-constructor.component.html',
  styleUrl: './formula-constructor.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormulaConstructorComponent),
      multi: true
    }
  ]
})
export class FormulaConstructorComponent implements ControlValueAccessor, OnInit {
  @Input() public label: string = '';


  private cdr = inject(ChangeDetectorRef)
  private formulaService = inject(FormulaControllerService);
  private toast = inject(CommunicationService);

  form = new FormGroup({
    formulaControl: new FormControl<string>('')
  })

  private onChange: (value: any) => void = () => {
  };
  private onTouched: () => void = () => {
  };
  message = signal<CheckFormulaResponse | null>(null);
  errorCheck = signal(false);

  writeValue(value: string): void {
    this.form.get('formulaControl')!.setValue(value);
    this.cdr.detectChanges();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }

  setDisabledState(isDisabled: boolean): void {
  }

  ngOnInit(): void {
    this.form.get('formulaControl')!.valueChanges.subscribe(value => {
      this.onChange(value);
    })
  }

  check() {
    const formula = this.form.get('formulaControl')!.value;
    if (!formula) {
      return this.toast.error('Введите формулу');
    }
    this.formulaService.apiFormulaValidatePost({apiFormulaValidatePostRequest: {formula}})
      .subscribe({
        next: (v: CheckFormulaResponse) => {
          this.message.set(v);
        },
        error: ()=>this.errorCheck.set(true)
      })
  }
}
